import React, { useState, useContext } from 'react';
import { UserContext } from '../app/app';
import { v4 as uuid } from 'uuid';
import { getData, updateData } from '../firebase';

import '../scss/buttons.scss';
import './gift-edit.scss';

const GiftEdit = ({ close, ...gift }) => {
  const { currentUser, users } = useContext(UserContext);
  
  const giftData = gift.uuid ? gift : {
      order: 0,
      uuid: uuid(),
      name: '',
      details: '',
      price: '',
      url: '',
      image: '',
    }
  
  const [formData, setFormData] = useState(giftData);

  const findUserByUserId = (userId) =>
    Object.entries(users).filter(([, u]) => u.userId === userId);

  // Firebase won't save `undefined` values
  const getFormValues = () => {
    const values = [
      'order',
      'uuid',
      'name',
      'details',
      'price',
      'url',
      'image',
    ];

    const data = {};
    values.forEach((key) => {
      if (formData[key] !== undefined) {
        data[key] = formData[key];
      }
    });

    return data;
  };

  const save = (e) => {
    e.preventDefault();

    let saveState = getFormValues();
    const currentUUID = findUserByUserId(currentUser.uid)[0][0];
    updateData(`users/${currentUUID}/gifts/${formData.uuid}`, saveState);

    close();
  };

  const handleChange = (e) => {
    let newData = { ...formData };
    newData[e.target.name] = e.target.value;
    setFormData(newData);
  };

  return (
    <form className="gift-edit-form" onSubmit={save}>
      <input
        type="hidden"
        name="order"
        value={formData.order}
        onChange={handleChange}
      />
      <label className="gift-edit-label">
        <span className="gift-edit-label-text">Name:</span>
        <input
          className="gift-edit-input"
          type="text"
          name="name"
          required
          value={formData.name}
          onChange={handleChange}
        />
      </label>
      <label className="gift-edit-label">
        <span className="gift-edit-label-text">Details:</span>
        <input
          className="gift-edit-input"
          type="text"
          name="details"
          value={formData.details}
          onChange={handleChange}
        />
      </label>
      <label className="gift-edit-label">
        <span className="gift-edit-label-text">Price:</span>
        <input
          className="gift-edit-input"
          type="text"
          name="price"
          value={formData.price}
          onChange={handleChange}
        />
      </label>
      <label className="gift-edit-label">
        <span className="gift-edit-label-text">URL:</span>
        <input
          className="gift-edit-input"
          type="text"
          name="url"
          value={formData.url}
          onChange={handleChange}
        />
      </label>
      <label className="gift-edit-label">
        <span className="gift-edit-label-text">Image URL:</span>
        <input
          className="gift-edit-input"
          type="text"
          name="image"
          value={formData.image}
          onChange={handleChange}
        />
      </label>
      <input type="submit" value="Save" className="gift-edit-submit" />
      <input
        type="reset"
        value="Cancel"
        className="gift-edit-cancel"
        onClick={close}
      />
    </form>
  );
};

export default GiftEdit;
